import React from "react";
import { FaInstagram, FaFacebookF, FaTiktok, FaLinkedin } from "react-icons/fa";
import "./footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__container">

        {/* Brand */}
      <div className="footer__col">
  <img src="/Tote.png" alt="Tote Therapy Logo" className="footer__logo" />

  <p className="footer__text">
  Carry your calm in a city that never slows down.
Thoughtfully designed for everyday life.
  </p>

  <div className="footer__socials">
    
    <a 
      href="https://www.instagram.com/thetotetherapy?igsh=MWo0bDVwb3VpZDFxeg%3D%3D&utm_source=qr" 
      target="_blank" 
      rel="noopener noreferrer"
      aria-label="Instagram" 
      className="footer__icon"
    >
      <FaInstagram />
    </a>

    <a 
      href="https://www.facebook.com/share/1BsmevoyGc/?mibextid=wwXIfr" 
      target="_blank" 
      rel="noopener noreferrer"
      aria-label="Facebook" 
      className="footer__icon"
    >
      <FaFacebookF />
    </a>

    <a 
      href="https://www.tiktok.com/@thetotetherapy?_r=1&_t=ZS-94B37p3P9ds" 
      target="_blank" 
      rel="noopener noreferrer"
      aria-label="TikTok" 
      className="footer__icon"
    >
      <FaTiktok />
    </a>
    <a 
      href="https://www.linkedin.com/company/thetotetherapy/" 
      target="_blank" 
      rel="noopener noreferrer"
      aria-label="TikTok" 
      className="footer__icon"
    >
      <FaLinkedin />
    </a>

  </div>
</div>

        {/* Links */}
        <div className="footer__col">
          <h4 className="footer__title">Quick Links</h4>
          <a className="footer__link" href="/">Home</a>
          <a className="footer__link" href="/shop">Shop</a>
          <a className="footer__link" href="/about">About</a>
          <a className="footer__link" href="/contact">Contact</a>
        </div>

        {/* Support */}
        <div className="footer__col">
          <h4 className="footer__title">Support</h4>
          <a className="footer__link" href="/faq">FAQ</a>
          <a className="footer__link" href="/shipping-policy">Shipping</a>
          <a className="footer__link" href="/returns-policy">Returns</a>
          <a className="footer__link" href="/privacy-policy">Privacy Policy</a>
          <a className="footer__link" href=" /sustainability">Sustainability Promise</a>
        </div>

        {/* Newsletter */}
        <div className="footer__col">
          <h4 className="footer__title">Newsletter</h4>
          <p className="footer__text">
            Get updates, offers and new arrivals.
          </p>

          <form className="footer__form" onSubmit={(e) => e.preventDefault()}>
            <input
              className="footer__input"
              type="email"
              placeholder="Enter your email"
              required
            />
            <button className="footer__btn" type="submit">Subscribe</button>
          </form>
        </div>
      </div>

      <div className="footer__bottom">
        <p>© {new Date().getFullYear()} Tote Therapy. All rights reserved.</p>
      </div>
    </footer>
  );
}